// ViewBox for SerbiaMap is 0 0 347 507
// These centroids are approximate label anchors visually centered within each okrug

// Human-readable display names for each okrug key (Serbian, Cyrillic)
export const OKRUG_NAMES = {
  severnobacki: 'Севернобачки',
  zapadnobacki: 'Западнобачки',
  juznobacki: 'Јужнобачки',
  severnobanatski: 'Севернобанатски',
  srednjobanatski: 'Средњобанатски',
  juznobanatski: 'Јужнобанатски',
  sremski: 'Сремски',
  macvanski: 'Мачвански',
  kolubarski: 'Колубарски',
  zlatiborski: 'Златиборски',
  moravicki: 'Моравички',
  raski: 'Рашки',
  rasinski: 'Расински',
  sumadijski: 'Шумадијски',
  beogradski: 'Београдски',
  pomoravski: 'Поморавски',
  podunavski: 'Подунавски',
  branicevski: 'Браничевски',
  borski: 'Борски',
  zajecarski: 'Зајечарски',
  nisavski: 'Нишавски',
  toplicki: 'Топлички',
  pirotski: 'Пиротски',
  jablanicki: 'Јабланички',
  pcinjski: 'Пчињски',
  kosovski: 'Косовски',
  pecki: 'Пећки',
  prizrenski: 'Призренски',
  kosovskomitrovacki: 'Косовскомитровачки',
  kosovskopomoravski: 'Косовскопоморавски',
};

export const OKRUG_CENTROIDS = {
  // Vojvodina (7)
  severnobacki: { x: 65, y: 30 },
  zapadnobacki: { x: 30, y: 55 },
  juznobacki: { x: 70, y: 97 },
  severnobanatski: { x: 105, y: 28 },
  srednjobanatski: { x: 140, y: 90 },
  juznobanatski: { x: 175, y: 136 },
  sremski: { x: 75, y: 136 },

  // Central Serbia (17)
  macvanski: { x: 56, y: 185 },
  kolubarski: { x: 96, y: 220 },
  zlatiborski: { x: 70, y: 305 },
  moravicki: { x: 125, y: 275 },
  raski: { x: 145, y: 328 },
  rasinski: { x: 195, y: 308 },
  sumadijski: { x: 165, y: 247 },
  beogradski: { x: 129, y: 177 },
  pomoravski: { x: 214, y: 255 },
  podunavski: { x: 178, y: 205 },
  branicevski: { x: 222, y: 205 },
  borski: { x: 282, y: 215 },
  zajecarski: { x: 272, y: 288 },
  nisavski: { x: 250, y: 328 },
  toplicki: { x: 210, y: 352 },
  pirotski: { x: 310, y: 357 },
  jablanicki: { x: 255, y: 377 },
  pcinjski: { x: 265, y: 426 },

  // Kosovo & Metohija (5)
  kosovski: { x: 190, y: 426 },
  pecki: { x: 122, y: 417 },
  prizrenski: { x: 153, y: 460 },
  kosovskomitrovacki: { x: 165, y: 380 },
  kosovskopomoravski: { x: 220, y: 426 },
};

// Optional mapping for common name variants to our normalized keys
export const OKRUG_ALIASES = {
  raska: 'raski',
  rashki: 'raski',
  'raški': 'raski',
  'kosovsko-mitrovacki': 'kosovskomitrovacki',
  'kosovsko mitrovacki': 'kosovskomitrovacki',
  mitrovacki: 'kosovskomitrovacki',
  'pecki okrug': 'pecki',
  'pećki': 'pecki',
  pec: 'pecki',
  urosevac: 'kosovski',
  'uroševacki': 'kosovski',
  pristinski: 'kosovski',
  'prištinski': 'kosovski',
  gnjilane: 'kosovskopomoravski',
  gnjilanski: 'kosovskopomoravski',
  'Јужнобачки управни округ': 'juznobacki',
};

// Mapping of SerbiaMap fallback region indices to okrug keys
export const INDEX_TO_OKRUG_KEY = {
  31: 'podunavski',
  2: 'zlatiborski',
  3: 'juznobanatski',
  4: 'juznobacki',
  5: 'branicevski',
  6: 'raski',
  7: 'zajecarski',
  8: 'pcinjski',
  9: 'sremski',
  10: 'borski',
  11: 'srednjobanatski',
  12: 'macvanski',
  13: 'beogradski',
  14: 'moravicki',
  15: 'kosovski',
  16: 'jablanicki',
  17: 'pirotski',
  18: 'pomoravski',
  19: 'nisavski',
  20: 'rasinski',
  21: 'kolubarski',
  22: 'zapadnobacki',
  23: 'severnobanatski',
  24: 'sumadijski',
  25: 'pecki',
  26: 'toplicki',
  27: 'kosovskomitrovacki',
  28: 'prizrenski',
  29: 'severnobacki',
  30: 'kosovskopomoravski',
};
